import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { fetchAuthenticatedUser } from '../../actions';
import { pollForSubscriptionStatus } from '../BillingForm/helpers';

// Extracts the "wait until the member is back on Power" recovery poll (formerly inline in
// SubscriptionsPageV2.handlePollForRecovery) so any surface can gate a deferred action on recovery
// without duplicating the loop (TMS-2338 deliverable 8). `isRecovering` drives the modal's loading
// state; `runRecovery` polls fetchAuthenticatedUser until hasPastDueSubscription clears (or retries
// exhaust) and resolves to whether recovery was confirmed. Callers own their own success/failure UI.
const useSubscriptionRecovery = () => {
    const dispatch = useDispatch();
    const [isRecovering, setIsRecovering] = useState(false);

    const runRecovery = useCallback(async ({ fetchUser, maxRetries, retryDelayMs } = {}) => {
        const resolvedFetchUser = fetchUser || (() => dispatch(fetchAuthenticatedUser()));
        setIsRecovering(true);
        try {
            return await pollForSubscriptionStatus({
                fetchUser: resolvedFetchUser,
                expectPastDue: false,
                maxRetries,
                retryDelayMs,
            });
        } finally {
            setIsRecovering(false);
        }
    }, [dispatch]);

    return { isRecovering, runRecovery };
};

export default useSubscriptionRecovery;
